import {IConsumables, IConsumablesListItem, ConsumablesResponseType} from "@/entity/consumables/consumables.types";

export default class Consumables implements IConsumables {
    total: number;
    data: IConsumablesListItem[] = [];
    constructor(data: ConsumablesResponseType) {
        this.total = data.total;
        for (let i = 0; i < data.data.length; i++) {
            this.data.push(data.data[i]);
        }
    }
}